import { IState } from '../../../store';

export function selectGeoCoordinates(state: IState) {
  return state.offerData.offer.geo.coordinates;
}
